<mat-dialog-actions class="justify-content-between">
        <h3>{{ 'LABEL.ADD_LABEL' | translate }} {{ 'LABEL.NATURE_OF_TREATMENT' | translate }}</h3>
    <button mat-icon-button mat-dialog-close class="d-flex justify-content-center">
        <i-tabler name="x" class="icon-20 d-flex"></i-tabler>
    </button>
</mat-dialog-actions>
<mat-divider></mat-divider>
<mat-dialog-content class="mat-typography">
    <form [formGroup]="natureOfTreatmentForm">
        <div class="row m-t-10">
            <div class="col-lg-12">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'LABEL.NATURE_OF_TREATMENT' | translate }}</mat-label>
                    <input matInput placeholder="{{ 'LABEL.NATURE_OF_TREATMENT' | translate }}" formControlName="name">
                   <mat-error *ngIf="natureOfTreatmentForm.get('name')?.hasError('required') && 
                    (natureOfTreatmentForm.get('name')?.dirty || natureOfTreatmentForm.get('name')?.touched)">
                        {{ 'REQUIRED.NAME' | translate }}
                    </mat-error>
                    <mat-error *ngIf="natureOfTreatmentForm.get('name')?.hasError('maxlength')">
                        {{ 'REQUIRED.MAXIMUM100' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

    </form>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-actions>
    <div class="row m-t-4 p-r-16">
        <div class="col-lg-8"></div>
        <div class="col-lg-4 d-flex justify-content-end">
            <button mat-stroked-button class="m-r-5" (click)="onCloseDialog()">{{ 'BUTTON.BTN_CLOSE' | translate
                }}</button>

            <button mat-flat-button color="primary" class=" m-l-4" (click)="onSaveNatureOfTreatment()"
            [disabled]="natureOfTreatmentForm.invalid">
                {{ 'BUTTON.BTN_SAVE' | translate }}</button>
        </div>
    </div>
</mat-dialog-actions>
